// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"570bd5a2","453":"3ea81907"}[chunkId] + ".chunk.js";
};